export default "__VITE_ASSET__DnyDWZ3$__"